module.exports = __webpack_public_path__ + "logo-orkla-tagline-no-white-569ee305732c6bb338e5162ae21959d6.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-no-white.svg
// module id = 68
// module chunks = 0